<template>
 <div class="UploadRecommendation">
  <MobileNav :page_title="nav_title" :isFilterRequired="false"></MobileNav>

  <div class="action-container">
   <div class="search-stock-section">
    <div class="stock-input">
     <search-stock class="search-stock-component"></search-stock>

     <!-- <div class="download-btn" @click="goToBulkUpload()">BULK UPLOAD</div>  -->
     <div v-if="userProfile && userProfile.mark_as_verified_user">
      <el-button class="create-post-btn" @click="dialogVisible = true">
       <i class="el-icon-edit"></i>
       Create Post
      </el-button>
     </div>
    </div>
   </div>
  </div>

  <div class="uploadForeCastedEstimateContainer">
   <div class="reco-list-section">
    <div v-if="!is_stock_list_loading && !stock_list.length">
     <NoDataFound></NoDataFound>
    </div>

    <!-- stock list section -->
    <el-row :gutter="15">
     <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-for="(item, index) in stock_list" :key="index">
      <el-card class="box-card relative" :class="{ 'searched-stock-card': item.is_searched_stock }">
       <div style="display: flex; justify-content: space-between">
        <div class="flex">
         <div class="stock-title ellipsis" :title="item.name">
          {{ item.name }}
         </div>
         &nbsp;&nbsp;
         <span class="code-title" :title="item.name" v-if="item.symbol">({{ item.symbol }})</span>

         <div class="download-btn" style="margin-left: 10px" v-if="item.symbol" @click="openStockWidget(item.symbol)">More</div>
        </div>

        <span class="flex">
         <span v-if="!item.add_to_my_fav" title="Add to favourite" class="left-margin-10 cursor-pointer" @click="addToFavourite(index)">
          <img src="../assets/images/company/inActiveHeart.svg" width="14" />
         </span>

         <span v-if="item.add_to_my_fav" title="Remove from favourite" class="left-margin-10 cursor-pointer" @click="addToFavourite(index)">
          <img src="../assets/images/company/activeHeart.svg" width="14" />
         </span>
         <!-- <span class="cross-icon cursor-pointer" title="Remove" @click="removeStockFromList(index)">&#x2715;</span> -->
        </span>
       </div>

       <div class="border-bottom-gray">
        <el-row class="top-margin-10 stock-details-section">
         <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <span class="current-price right-margin-10">₹ {{ item.current_price }}</span>
          <span class="right-margin-10 stock-section-inc" :style="[item.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
           <span style="font-size: 18px" v-if="item.price_difference >= 0">&#9652;</span>
           <span style="font-size: 18px" v-else>&#9662;</span>
           {{ item.price_difference }} ({{ item.potential_difference }}%)
          </span>
         </el-col>

         <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="sector-capitalized-section">
          <div>
           <el-tag size="mini" class="right-margin-10 sector-tag" title="Market size" effect="plain" type="info">
            {{ item.market_cap }}
           </el-tag>

           <el-select v-model="item.sector" placeholder="Sector" size="mini" title="Sector" class="sector-dropdown" @focus="getSectorWiseStockList(item.sector)" @change="selectSector(item.sector, index)">
            <el-option v-for="sector in sector_wise_stock_list" :key="sector.id" :label="sector.name" :value="sector"></el-option>
           </el-select>
          </div>
         </el-col>
        </el-row>

        <div class="input-label-gray" style="font-size: 10px" v-if="item.current_datetime">
         {{ item.current_datetime | stock_live_price_date_filter }}
        </div>
       </div>

       <div class="top-margin-10">
        <el-row :gutter="10">
         <el-col :xs="24" :sm="12" :md="24" :lg="10" :xl="10">
          <div class="input-label-gray font-weight-500">
           My Opinion
           <el-popover placement="bottom" title="My Opinion" width="150" trigger="click" content="Select opinion">
            <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
           </el-popover>
          </div>

          <div class="top-margin-5 bottom-margin-20">
           <el-tag size="mini" class="selection-tag" value="Buy" :class="[item.reco == 'Buy' ? 'active-period-type' : 'inactive-period-type-tag']" @click="selectRecoType(item.current_price, index, 'Buy')">BUY</el-tag>

           <el-tag size="mini" class="selection-tag" value="Sell" :class="[item.reco == 'Sell' ? 'active-period-type' : 'inactive-period-type-tag']" @click="selectRecoType(item.current_price, index, 'Sell')">SELL</el-tag>
          </div>
         </el-col>

         <el-col :xs="24" :sm="12" :md="24" :lg="14" :xl="14">
          <el-row :gutter="5">
           <el-col :xs="12" :sm="12" :md="12" :lg="10" :xl="10" class="relative">
            <div class="input-label-gray font-weight-500">
             Reco Price
             <el-popover placement="bottom" title="Reco Price" width="225" trigger="click" content="Price estimate (potential return in %)">
              <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
             </el-popover>
            </div>

            <div class="top-margin-5">
             <div class="target-price-input-section width-100" v-if="item.reco_price_type != 'MARKET'">
              <div class="relative">
               <span class="rupees-symbol">₹</span>

               <span class="potential-return-value" v-if="item.reco_price_potential != ''">{{ item.reco_price_potential }} %</span>
               <span class="potential-return-value" v-else>0 %</span>

               <el-input size="small" class="target-price-input" placeholder="Reco price" v-model="item.reco_price" @input.native="validateRecoPrice($event, index, item.target_price, 'input', item.reco)"></el-input>
              </div>
             </div>
             <el-input v-if="item.reco_price_type == 'MARKET'" size="small" class="target-price-input" placeholder="LTP" v-model="reco_price_market" :disabled="item.reco_price_type == 'MARKET'"></el-input>
            </div>

            <div class="top-margin-5">
             <el-popover class="error-pop" placement="top" width="280" trigger="click" v-model="item.validate_reco_price" :content="item.reco_price_error_text"></el-popover>
            </div>
           </el-col>

           <el-col :xs="12" :sm="12" :md="12" :lg="14" :xl="14" class="relative">
            <div class="top-margin-25 left-margin-10">
             <el-radio :disabled="isMarketClose" v-model="item.reco_price_type" label="MARKET">Market</el-radio>
             <el-popover
              placement="bottom"
              title="Market"
              width="225"
              word-break="normal"
              trigger="click"
              content=" This recommendation will be published on the current
                          market price."
             >
              <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
             </el-popover>
             <el-radio v-model="item.reco_price_type" label="LIMIT" class="left-margin-5">Limit</el-radio>
            </div>
            <!-- <p
                          class="input-label-gray font-weight-500"
                          v-if="item.reco_price_type == 'MARKET'"
                        >
                          This recommendation will be published on the current
                          market price.
                        </p> -->
           </el-col>
          </el-row>
         </el-col>
        </el-row>

        <el-row :gutter="10" class="top-margin-10">
         <el-col :xs="24" :sm="12" :md="24" :lg="10" :xl="10">
          <div>
           <div class="input-label-gray font-weight-500">
            Target Period
            <span class="required-field">*</span>
           </div>
           <div class="top-margin-5">
            <el-select v-model="item.selected_target_period" placeholder="Target Period" size="small" class="quarter-tag" style="width: 100%" @change="selectedTargetList(item.selected_target_period, index)">
             <el-option v-for="item in target_period_type_list" :key="item.label" :label="item.label" :value="item.value"></el-option>
            </el-select>
           </div>
           <div class="input-label-gray font-weight-500 top-margin-10 duration-margin">
            Duration
            <span class="required-field">*</span>
           </div>
           <div class="top-margin-5">
            <el-select v-model="item.result_date" placeholder="Duration" size="small" style="width: 100%" class="quarter-tag bottom-margin-10" :disabled="!item.selected_target_period">
             <el-option v-for="item in item.target_period_array" :key="item.result_date_title" :label="item.result_date_title + ' (' + item.label + ')'" :value="item.result_date"></el-option>
            </el-select>
           </div>
          </div>
         </el-col>

         <el-col :xs="24" :sm="12" :md="24" :lg="14" :xl="14" class="relative">
          <el-row :gutter="10">
           <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <div class="input-label-gray font-weight-500">
             Target Price
             <span class="required-field">*</span>
             <el-popover placement="bottom" title="Target Price" width="225" trigger="click" content="Price estimate (potential return in %)">
              <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
             </el-popover>
            </div>

            <div class="top-margin-5">
             <div class="target-price-input-section width-100">
              <div class="relative">
               <span class="rupees-symbol">₹</span>

               <span class="potential-return-value" v-if="item.target_price_potential != ''">{{ item.target_price_potential }} %</span>
               <span class="potential-return-value" v-else>0 %</span>
               <span v-if="item.reco == 'Buy'">
                <el-input size="small" class="target-price-input" placeholder="Target price" min="0" type="number" v-model="item.target_price" :max="item.target_price_limit" @input.native="validateTargetPrice(item.target_price, index, item.reco)" @change="calculateStopLoss(item.reco_price, item.target_price, index)"></el-input>
               </span>
               <span v-else-if="item.reco == 'Sell'">
                <el-input size="small" class="target-price-input" placeholder="Target price" min="0" type="number" v-model="item.target_price" :max="item.target_price_limit" @input.native="validateTargetPrice(item.target_price, index, item.reco)" @change="calculateStopLoss(item.reco_price, item.target_price, index)"></el-input>
               </span>
              </div>
             </div>
            </div>

            <div class="top-margin-5">
             <el-popover class="error-pop" placement="top" width="280" trigger="click" v-model="item.validate_target_price" :content="item.target_price_error_text"></el-popover>
            </div>
           </el-col>

           <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
  <div class="input-label-gray font-weight-500">
    Stop Loss
    <span v-if="item.selected_target_period == 'Intra' || item.selected_target_period == 'Short-Term' || item.selected_target_period == 'Mid-Term'" class="required-field">*</span>
    <el-popover
      placement="bottom"
      title="Stop Loss"
      width="225"
      trigger="click"
      content="Price estimate (potential return in %)"
    >
      <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
    </el-popover>
  </div>

  <div class="top-margin-5">
    <div class="target-price-input-section width-100">
      <div class="relative">
        <span class="rupees-symbol">₹</span>
        <span class="potential-return-value" v-if="item.stop_loss_potential != ''">{{ item.stop_loss_potential }} %</span>
        <span class="potential-return-value" v-else>0 %</span>

        <el-input v-model="item.stop_loss" size="small" class="target-price-input" placeholder="Stop loss" :min="item.reco === 'Buy' ? item.stop_loss_limit : 1" :max="item.reco === 'Sell' ? item.stop_loss_limit : 1" type="number" :disabled="item.reco == 'Hold' || item.long_term_duration != ''" @input.native="validateStopLoss(item.stop_loss, index, item.current_price, item.reco)" ></el-input>
      </div>
    </div>
  </div>

  <div class="top-margin-5">
    <el-popover class="error-pop" placement="bottom" width="280" trigger="click" v-model="item.validate_stop_loss" :content="item.stop_loss_error_text"></el-popover>
  </div>
</el-col>
<div class="">
           <p class="note-text" style="">Note: Risk-Reward Ratio for this recommendation is below 1:1</p>
          </div>
          </el-row>
         </el-col>

         <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14">
          <div class="input-label-gray font-weight-500 top-margin-5">
           Risk Tag
           <span class="required-field">*</span>
          </div>
          <div class="top-margin-5">
           <el-select v-model="item.risk_tags" placeholder="Add Risk tag" size="small" style="width: 100%" class="bottom-margin-10" @change="selectedRiskTag(item.risk_tags, index)">
            <el-option v-for="option in risk_tags_options" :key="option.value" :label="option.label" :value="option.value"></el-option>
           </el-select>
          </div>
         </el-col>
        </el-row>
       </div>

       <!-- recommend btn -->

       <div class="recommendation-section top-margin-10">
        <div class="top-margin-15 flex-end">
         <el-button class="btn-theme-filled" size="small" round plain v-if="!item.is_recommended" :loading="item.is_btn_loading" v-on:click="openLogicReferenceDialog(item, index)" style="width: 100px">LOGIC</el-button>

         <el-button class="btn-theme-filled" size="small" round icon="el-icon-check" plain v-if="item.is_recommended" :loading="item.is_btn_loading" style="cursor: not-allowed; width: 150px">PUBLISHED</el-button>
        </div>
       </div>

       <div class="primary-theme-color text-center label-xs-bold" v-if="item.is_summary_out">
        <el-popover placement="top" width="500" trigger="click">
         <div class="flex" style="justify-content: space-between">
          <el-tag size="mini" style="border-color: #2d2e8d; background-color: #2d2e8d; color: #fff; font-size: 9px">RECO PRICE : {{ item.current_price }}</el-tag>

          <span class="primary-theme-color cursor-pointer" @click="downloadSummaryPdf(userProfile, item)">DOWNLOAD</span>
         </div>

         <table class="summary-table top-margin-15 bottom-margin-15" id="summary">
          <thead>
           <tr>
            <th>Target period</th>
            <th>Reco</th>
            <th>Target price</th>
            <th>Antestimate</th>
           </tr>
          </thead>
          <tbody>
           <tr>
            <td>{{ item.summary_list.target_period }}</td>
            <td>{{ item.summary_list.reco }}</td>
            <td>{{ item.summary_list.target_price }} ({{ item.summary_list.target_potential }})</td>
            <td>
             {{ item.summary_list.antsestimate_number ? item.summary_list.antsestimate_number : 'NA' }}
            </td>
           </tr>
          </tbody>
         </table>

         <span slot="reference" class="cursor-pointer">Summary</span>
        </el-popover>
       </div>
       <div v-else>
        &nbsp;
        <br />
       </div>
      </el-card>
     </el-col>
    </el-row>

    <div class="text-center" v-if="is_stock_list_loading">
     <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
    </div>
   </div>
  </div>

  <div class="show-more-tab" v-if="this.number_of_pages > this.page_no" @click="loadStocks()">Load more</div>

  <!-- stock widget dialog -->
  <el-dialog custom-class="stock-widget-dialog" :visible.sync="stock_widget_visible" :before-close="handleClose">
   <div>
    <iframe :src="'https://stocks.tickertape.in/' + stock_code + '?broker=stockants'" width="100%" height="400px"></iframe>
   </div>
  </el-dialog>

  <!-- upload reco logic dialog -->
  <el-dialog custom-class="upload-logic-dialog" :visible.sync="upload_logic_reference_dialog_visible" :before-close="handleLogicDialogClose" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true">
   <div>
    <div>
     <div class="font-09rem font-weight-600 bottom-margin-10 top-margin-20">Logic</div>

     <el-input type="textarea" :rows="4" resize="none" placeholder="Write a brief description..." v-model="logic_description"></el-input>
    </div>

    <el-row :gutter="15">
     <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <div class="font-09rem font-weight-600 bottom-margin-10 top-margin-20">
       Tags
       <span class="required-field">*</span>
       <span style="font-size: 9px">(Min 3)</span>
      </div>
      <div class="top-margin-5">
       <el-select v-model="selected_logic_list" placeholder="Logic tags" size="small" style="width: 100%" multiple class="bottom-margin-10">
        <el-option v-for="option in filtered_logic_list" :key="option.value" :label="option" :value="option"></el-option>
       </el-select>
      </div>
     </el-col>
     <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <div class="font-09rem font-weight-600 bottom-margin-10 top-margin-20">
       Stamps
       <span class="required-field">*</span>
      </div>
      <div class="top-margin-5">
       <el-select v-model="selected_stamps_list" placeholder="Category Stamps" size="small" style="width: 100%" multiple class="bottom-margin-10">
        <el-option v-for="option in stamp_list" :key="option" :label="option" :value="option"></el-option>
       </el-select>
      </div>
     </el-col>
    </el-row>

    <div class="top-margin-10 flex">
     <div class="upload-btn" @click="$refs.file.click()">
      <i class="el-icon-document"></i>
      Upload +
     </div>

     <input ref="file" type="file" accept="image/*, application/pdf," multiple="multiple" style="display: none" @change="getAttachement()" />

     <div class="font-07rem font-weight-600 left-margin-10">Attachments - {{ attached_files_list.length }}</div>
    </div>

    <div slot="footer" class="dialog-footer top-margin-10 text-right">
     <el-button class="btn-secondary-theme-borderd" size="small" @click="handleLogicDialogClose()">Cancel</el-button>
     <!-- {{ stock_list[selected_stock_index] }} -->
     <el-button class="btn-theme-borderd" size="small" :loading="stock_list[selected_stock_index] && stock_list[selected_stock_index].is_btn_loading" @click="uploadReco(stock_list[selected_stock_index], selected_stock_index)">Publish</el-button>
    </div>
   </div>
  </el-dialog>
  <AccessPublisher />

  <div v-if="userProfile != null">
   <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
  </div>

  <CreatePostDialog v-model="dialogVisible" />
 </div>
</template>

<script>
import ProcessKycComponent from '@/components/NewKycFlow.vue';
import FilterForDeskTopView from '../components/FilterForDesktopView.vue';
import { serverAddr } from '../networkConfig';
import { UploadRecommendationsNetworkCallBack } from '../mixins/UploadRecommendations.Network';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { filterCallBack } from '../mixins/filter';
import NoDataFound from '@/components/NoDataFound.vue';
import SearchStock from '@/components/SearchStock.vue';
import MobileNav from '@/components/MobileNav.vue';
import AccessPublisher from '@/components/AccessPublisher.vue';
import CripNotice from 'crip-vue-notice';
import { EventBus } from '../eventBus';
import { some } from 'lodash';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import LivePriceTickerVue from '../components/LivePriceTicker.vue';
import CreatePostDialog from '@/components/CreatePostDialog.vue';

export default {
 name: 'UploadRecommendation',

 mixins: [UploadRecommendationsNetworkCallBack, filterCallBack, HelperNetworkCallBack],

 components: {
  NoDataFound,
  'search-stock': SearchStock,
  MobileNav,
  FilterForDeskTopView,
  AccessPublisher,
  ProcessKycComponent,
  CreatePostDialog,
 },

 data() {
  return {
   planSubscriptionStatusDetails: null,
   moment: moment,
   nav_title: 'Upload Recommendations',
   firstActionBtnLink: '/upload-long-term-reco-link',
   secondActionBtnLink: '/upload-recommendation',
   activeBtn: 'shortTerm',
   recos_to_be_upload: [],
   is_stock_list_loading: true,
   sector_wise_stock_list: [],
   stock_list: [],
   intra_target_period_list: [],
   short_term_target_period_list: [],
   mid_term_target_period_list: [],
   long_term_target_period_list: [],
   page_no: 1,
   is_scroll_disabled: true,
   isMarketClose: false,
   number_of_pages: null,
   stock_code: '',
   stock_widget_visible: false,
   upload_logic_reference_dialog_visible: false,
   logic_description: '',
   attached_files_list: [],
   reco_price_market: '',
   selectedTagList: [], // Default to an empty string
   filtered_logic_list: [], // Default to an empty string
   selected_logic_list: [],
   dialogVisible: false,
   target_period_type_list: [
    {
     label: 'Intraday',
     value: 'Intra',
    },
    {
     label: 'Short Term',
     value: 'Short-Term',
    },
    {
     label: 'Mid Term',
     value: 'Mid-Term',
    },
    {
     label: 'Long Term',
     value: 'Long-Term',
    },
   ],

   risk_tags_options: [
    {
     label: 'Low Risk',
     value: 'low_risk',
    },
    {
     label: 'Moderate Risk',
     value: 'moderate_risk',
    },
    {
     label: 'High Risk',
     value: 'high_risk',
    },
   ],

   tags_data: {
    intraday: {
     buy: ['Scalping', 'Range Trading', 'News Based', 'Technical Based', 'Bullish Chart Pattern', 'Arbitrage', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bullish Reversal', 'Volatility', 'Uptrend', 'Breakout', 'Support Zone', 'Trade Volume Based'],
     sell: ['Scalping', 'Range Trading', 'News Based', 'Technical Based', 'Bearish Chart Pattern', 'Arbitrage', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bearish Reversal', 'Volatility', 'Downtrend', 'Breakout', 'Resistance Zone', 'Trade Volume Based'],
    },

    short_term: {
     buy: ['BTST Trade', 'Swing Trade', 'News Based', 'Technical Based', 'Bullish Chart pattern', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bullish Reversal', 'Volatility', 'Postional Trading', 'Momentum Trading', 'Support Zone', 'Uptrend'],
     sell: ['BTST Trade', 'Swing Trade', 'News Based', 'Technical Based', 'Bearish Chart pattern', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bearish Reversal', 'Volatility', 'Positional Trading', 'Momentum Trading', 'Resistance Zone', 'Downtrend'],
    },

    long_term: {
     buy: ['Lower Charges/Commissions', 'Fundamental Based', 'High Profit Probability', 'Better Long-term Returns', 'Dividends', 'Compounding', 'Uptrend', 'LowerTax Rates'],
     sell: ['Lower Charges/Commissions', 'Fundamental Based', 'High Profit Probability', 'Better Long-term Returns', 'Dividends', 'Compounding', 'Downtrend', 'LowerTax Rates'],
    },
   },
   filteredTags: [],
   selected_stock_index: null,
   selected_stamps_list: [],
   stamp_list: ['SIP', 'Momentum Picks', 'FII/DII Activity', 'News based', 'Undiscovered gems', 'Multibagger'],
  };
 },

 beforeRouteEnter(to, from, next) {
  if (localStorage.getItem('profile')) {
   setTimeout(() => {
    var userProfile = JSON.parse(localStorage.getItem('profile'));

    if (userProfile && userProfile.profession == 'Retail Investor') {
     next({ name: 'expertsPastRecommendations' });
    }
   }, 0);
  }
  next();
 },

 watch: {
  getPlanSubscriptionStatus(newValue, oldValue) {
   this.planSubscriptionStatusDetails = newValue.message;

   if (this.planSubscriptionStatusDetails && this.planSubscriptionStatusDetails.extra_info.transaction_status == 'SUCCESS') {
    if (this.planSubscriptionStatusDetails.data.plan == 'Publisher') {
     localStorage.setItem('publisher_plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
    } else {
     localStorage.setItem('plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
    }

    this.$store.commit('commitKycDialog', true);
   }
  },
 },
 mounted() {
  this.checkMarketStatus();
  if (this.$route.params.stock_name) {
   //if stock name then called get stock by stock name api
   this.getStockById(this.$route.params.stock_name);
  } else {
   this.getStocks();
  }

  // this.userProfile.mark_as_verified_user = true;
  //called api to initially get stocks
  // this.loadMoreStocks();
  // window.addEventListener('scroll', this.loadMoreStocks());

  EventBus.$on('selectedStock', (stock) => {
   if (!some(this.stock_list, { name: stock.name })) {
    this.stock_list.unshift(stock);

    let price = Number(this.stock_list[0].current_price + 2).toFixed(); //increase price by 1

    //calculated potential return initially when target price is initiallised
    let reco_price_potential = this.getPotentailReturn(this.stock_list[0].current_price, this.stock_list[0].current_price, 'Buy');
    let target_price_potential = this.getPotentailReturn(price, this.stock_list[0].current_price, 'Buy');

    // this.$set(this.stock_list[0], 'isTargetPriceDisabled', false);
    this.$set(this.stock_list[0], 'duration', '');
    this.$set(this.stock_list[0], 'result_date', '');
    this.$set(this.stock_list[0], 'short_term_duration', '');
    this.$set(this.stock_list[0], 'long_term_duration', '');
    this.$set(this.stock_list[0], 'target_period_type', '');
    this.$set(this.stock_list[0], 'selected_target_period', '');
    this.$set(this.stock_list[0], 'target_period_array', []);
    this.$set(this.stock_list[0], 'risk_tags_options', '');
    this.$set(this.stock_list[0], 'risk_tags', '');
    this.$set(this.stock_list[0], 'selected_logic_list', []);
    this.$set(this.stock_list[0], 'selected_stamps_list', []);
    this.$set(this.stock_list[0], 'filtered_logic_list', []);
    this.$set(this.stock_list[0], 'logic_description', '');
    this.$set(this.stock_list[0], 'stop_loss_limit', null);
    this.$set(this.stock_list[0], 'target_price_limit', null);
    this.$set(this.stock_list[0], 'added_first', '');

    this.$set(this.stock_list[0], 'is_unlocked', false);
    this.$set(this.stock_list[0], 'is_recommended', false);
    this.$set(this.stock_list[0], 'is_btn_loading', false);
    this.$set(this.stock_list[0], 'reco_price', Number(this.stock_list[0].current_price));
    // this.$set(this.stock_list[0], "target_price", price);
    this.$set(this.stock_list[0], 'target_price', null);
    this.$set(this.stock_list[0], 'stop_loss', '');
    this.$set(this.stock_list[0], 'reco', 'Buy');
    this.$set(this.stock_list[0], 'validate_stop_loss', false);
    this.$set(this.stock_list[0], 'validate_target_price', false);
    this.$set(this.stock_list[0], 'validate_reco_price', false);
    this.$set(this.stock_list[0], 'target_price_error_text', '');
    this.$set(this.stock_list[0], 'target_price_potential', 0);
    // this.$set(
    //   this.stock_list[0],
    //   "target_price_potential",
    //   target_price_potential
    // );
    this.$set(this.stock_list[0], 'reco_price_potential', reco_price_potential);
    this.$set(this.stock_list[0], 'stop_loss_potential', '');
    this.$set(this.stock_list[0], 'is_searched_stock', true); //created new key to apply style on searched stock care

    if (this.isMarketClose) {
     this.$set(this.stock_list[0], 'reco_price_type', 'LIMIT');
    } else {
     this.$set(this.stock_list[0], 'reco_price_type', 'MARKET');
    }

    this.scrollToTop(); //scroll to top when searched stock is selected
   }
  });
 },

 beforeDestroy() {
  EventBus.$off();
  // window.removeEventListener('scroll', this.loadMoreStocks());
  // this.is_scroll_disabled = false;
 },

 methods: {
  openAccessPublisherDialog() {
   // trigger any action when the button is clicked
  },
  selectedRiskTag(risk_tags, index) {},

  selectedTargetList(target_period, i) {
   if (target_period == 'Intra') {
    this.stock_list[i].target_period_array = this.intra_target_period_list;
   } else if (target_period == 'Short-Term') {
    this.stock_list[i].target_period_array = this.short_term_target_period_list;
   } else if (target_period == 'Mid-Term') {
    this.stock_list[i].target_period_array = this.mid_term_target_period_list;
   } else if (target_period == 'Long-Term') {
    this.stock_list[i].target_period_array = this.long_term_target_period_list;
   }
   this.$set(this.stock_list[i], 'result_date', '');

   this.getTagsDataList(this.stock_list[i].reco, target_period, i);
  },

  getTagsDataList(recoType, targetPeriod, i) {
   // clear selected list from logic dialog
   this.selected_logic_list = [];

   if (recoType && targetPeriod) {
    var periodMapping = {
     Intra: 'intraday',
     'Short-Term': 'short_term',
     'Mid-Term': 'short_term',
     'Long-Term': 'long_term',
    };

    var periodKey = periodMapping[targetPeriod];

    this.filtered_logic_list = this.tags_data && this.tags_data[periodKey] ? this.tags_data[periodKey][recoType.toLowerCase()] : [];
   }
  },

  checkMarketStatus() {
   var format = 'hh:mm:ss';

   // real time
   var time = moment();
   var todayDate = moment().format('YYYY-MM-DD');

   var beforeTime = moment('09:15:00', format);
   var afterTime = moment('15:30:00', format);

   if (time.isBetween(beforeTime, afterTime)) {
    serverAddr
     .get('/base/v1/holiday')
     .then((response) => {
      // check for market holiday
      this.isMarketClose = response.data.data.includes(todayDate) == true ? true : false;
     })
     .catch(function (error) {
      console.log(error);
     });
   } else {
    this.isMarketClose = true;
   }
  },
  async getStocks() {
   if (!this.intra_target_period_list.length && !this.short_term_target_period_list.length && !this.mid_term_target_period_list.length && !this.long_term_target_period_list.length) {
    let target_period_res = await this.getTargetPeriod();

    if (target_period_res.data.status && target_period_res.data.data.length) {
     this.intra_target_period_list = target_period_res.data.data.filter((e) => {
      return e.period == 'Intra';
     });
     this.short_term_target_period_list = target_period_res.data.data.filter((e) => {
      return e.period == 'Short-Term';
     });
     this.mid_term_target_period_list = target_period_res.data.data.filter((e) => {
      return e.period == 'Mid-Term';
     });

     this.long_term_target_period_list = target_period_res.data.data.filter((e) => {
      return e.period == 'Long-Term';
     });
    }
   }

   this.getAllStockList();
  },

  openStockWidget(stock_code) {
   this.stock_code = stock_code;
   this.stock_widget_visible = true;
  },

  // close stock widget dialog
  handleClose() {
   this.stock_widget_visible = false;
  },

  // close logic reference upload dialog
  handleLogicDialogClose() {
   // if (!this.selected_stock_index) {
   //   this.attached_files_list = [];
   //   this.logic_description = "";
   this.upload_logic_reference_dialog_visible = false;
   // }
  },

  // get attached logic references
  getAttachement() {
   let size = 0;
   this.attached_files_list = this.$refs['file'].files;
   // this.attached_files_list = this.attachment;

   for (let i = 0; i < this.attached_files_list.length; i++) {
    size += this.attached_files_list[i].size;
   }

   // check length if already uploaded some files

   if (this.attached_files_list && this.attached_files_list.length > 4) {
    this.$alert(`Maximum Files Allowed - 4`, 'Error!', {
     confirmButtonText: 'OK',
    });
    this.attached_files_list = [];
   }

   if (size > 1040 * 1024 * 5) {
    this.$alert(`Total size is too large. Allowed maximum size is 5 MB`, 'Error!', {
     confirmButtonText: 'OK',
    });
    this.attached_files_list = [];
   }
  },

  goToBulkUpload() {
   // if logged in user is not a paid subscriber then displayed subscribe plan dialog
   if (!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') {
    this.$store.commit('commitSubscribPlanDialogVisibility', true);
    return;
   }

   this.$router.push({ path: '/bulk-upload' });
  },

  downloadSummaryPdf(userProfile, stock) {
   var doc = new jsPDF('p', 'pt');
   let imgData = this.base64Logo();

   var res = doc.autoTableHtmlToJson(document.getElementById('summary'));
   // doc.autoTable(res.columns, res.data, {margin: {top: 80}});

   var header = function (data) {
    doc.setFontSize(10);
    doc.setTextColor(40);
    doc.setFontStyle('normal');
    doc.addImage(imgData, 'JPEG', 30, 30, 120, 45, 'center');

    doc.text(40, 90, `Name : ${userProfile.first_name} ${userProfile.last_name}`);
    doc.text(`Website : www.stockants.com`, 550, 90, 'right');
    doc.text(40, 120, `Stock name : ${stock.name}`);
    doc.text(40, 140, `Reco price : ${stock.current_price}`);
    doc.text(`Reco Date : ${new Date(stock.Today).toLocaleDateString()}`, 550, 120, 'right');
    doc.text(`Reco Type : Short term`, 550, 140, 'right');
   };

   var options = {
    beforePageContent: header,
    margin: {
     top: 160,
    },
    theme: 'plain',
    styles: {
     lineWidth: 0.01,
     lineColor: 0,
    },
   };

   doc.autoTable(res.columns, res.data, options);

   doc.save(`${userProfile.first_name}_reco_summary.pdf`);
  },

  scrollToTop() {
   var elmnt = document.getElementsByClassName('reco-list-section');
   scrollTo(elmnt, 0, 100);
  },

  //adds stocks to my favourite list
  addToFavourite(index) {
   let favList = [];
   let obj = {};

   obj.stock_id = this.stock_list[index].id;

   if (this.stock_list[index].add_to_my_fav) {
    obj.status = false; //if already added to favourite list then
   } else {
    obj.status = true; //if not added in fav list then
   }
   favList.push(obj);

   serverAddr
    .post('/stockants/add-to-favroite/', {
     favroite: favList,
     followers: [],
     company: [],
    })
    .then((response) => {
     this.addToFavListCallBack(response, index);
    })
    .catch(function (error) {
     console.log(error);
    });
  },

  //when reco type is changed then resets target period input and potential return
  selectRecoType(current_price, index, reco_type) {
   this.stock_list[index].reco = reco_type;
   this.stock_list[index].is_unlocked = false; //to disable check antestimate link
   this.stock_list[index].is_recommended = false; //reset is_recommended stock
   this.stock_list[index].validate_target_price = false; //disable validate price error

   // this.stock_list[index].isWeeklyRecommended = false;
   // this.stock_list[index].isMonthlyRecommended = false;
   // this.stock_list[index].isNextQuarterRecommended = false;
   // this.stock_list[index].isCurrentQuarterRecommended = false;
   // this.stock_list[index].isTargetPriceDisabled = false;

   this.$set(this.stock_list[index], 'is_summary_out', false); //to disable summary link
   this.$set(this.stock_list[index], 'is_summary_list', []);

   //to reset target price & potential return as per reco conditions
   if (this.stock_list[index].target_price) {
    this.resetPotentialReturnAndTargetPrice(reco_type, index);
   }
   this.stock_list[index].selected_target_period = null; // this is for clear the target period when reco type change

   this.getTagsDataList(this.stock_list[index].reco, this.stock_list[index].selected_target_period, index);
  },

  //if sector is changed from stock then remove previous
  // sector and add selected sector on that place and commit it again in store
  selectSector(item, index) {
   this.stock_list.splice(index, 1);
   this.stock_list.splice(index, 0, item);
  },

  //api called to get sectore wise stocks
  getSectorWiseStockList(sectorName) {
   this.sector_wise_stock_list = [];
   serverAddr
    .post('/recommendation/v1/read-stock', {
     key: 'sector',
     search: sectorName,
    })
    .then(this.getSectorWiseStockListCallBack)
    .catch(function (error) {
     console.log(error);
    });
  },

  //set active period type e.g. Week, Month
  setActivePeriod(index, label) {
   this.stock_list[index].is_unlocked = false; //to disable check antestimate in gaph tab
   this.stock_list[index].is_recommended = false; //to disable is recommended button

   this.$set(this.stock_list[index], 'is_summary_out', false); //to disable summary link
   this.$set(this.stock_list[index], 'is_summary_list', []);
  },

  setDuration(quarter, index) {
   this.stock_list[index].is_recommended = false;

   this.$set(this.stock_list[index], 'is_summary_out', false); //to disable summary link
   this.$set(this.stock_list[index], 'is_summary_list', []);
  },

  //go to antestimate link
  goToAntestimateLink(item) {
   // passed reco id passed stock_id and user_id
   let routeData = this.$router.resolve({
    name: 'unlockedAntEstimate',
    params: {
     reco_id: item.reco_id,
     user_id: this.userProfile.id,
     stock_id: item.id,
     duration: item.duration,
    },
   });
   window.open(routeData.href, '_blank');
  },

  // validate reco price input
  validateRecoPrice(price, index, current_price, event, reco_type) {
   let reg = /^[-+]?\d+(\.\d+)?$/; //regex for non negative values

   let reco_price = Number(price.target.value);
   let target_price = Number(current_price);
   let stock_price = Number(this.stock_list[index].current_price);

   this.stock_list[index].is_recommended = false;
   this.stock_list[index].is_unlocked = false; //to disable check antestimate link

   if (reco_type == 'Buy') {
    // rounded value using toFixed() because current price is a fractional value
    if (reg.test(reco_price) && reco_price > 0) {
     this.stock_list[index].validate_reco_price = false;
     this.stock_list[index].reco_price_potential = this.getPotentailReturn(reco_price, stock_price, reco_type);
     this.stock_list[index].target_price_potential = this.getPotentailReturn(target_price, reco_price, reco_type);

     // validate target price input
     if (this.stock_list[index].target_price <= reco_price) {
      this.stock_list[index].validate_target_price = true;

      this.stock_list[index].target_price_error_text = 'Target price must be greater than reco price';
     } else {
      this.stock_list[index].validate_target_price = false;
     }

     // validate stop loss input
     if (this.stock_list[index].stop_loss) {
      if (Number(this.stock_list[index].stop_loss) < reco_price) {
       this.stock_list[index].validate_stop_loss = false;
      } else {
       this.stock_list[index].validate_stop_loss = true;

       this.stock_list[index].stop_loss_error_text = 'Stop loss must be lower than reco price';
      }
     }
    } else {
     this.stock_list[index].reco_price_potential = this.getPotentailReturn(0, 0, reco_type);
     this.stock_list[index].validate_reco_price = true;
     this.stock_list[index].reco_price_error_text = 'Reco price must be positive integer';
    }
   } else if (reco_type == 'Sell') {
    if (reg.test(reco_price) && reco_price > 0) {
     this.stock_list[index].validate_reco_price = false;
     this.stock_list[index].reco_price_potential = this.getPotentailReturn(reco_price, current_price, reco_type);
     this.stock_list[index].target_price_potential = this.getPotentailReturn(target_price, reco_price, reco_type);

     // validate target price input
     if (this.stock_list[index].target_price < reco_price) {
      this.stock_list[index].validate_target_price = false;
     } else {
      this.stock_list[index].validate_target_price = true;

      this.stock_list[index].target_price_error_text = 'Target price must be lower than reco price';
     }

     // validate stop loss input
     if (this.stock_list[index].stop_loss) {
      if (Number(this.stock_list[index].stop_loss) > reco_price) {
       this.stock_list[index].validate_stop_loss = false;
      } else {
       this.stock_list[index].validate_stop_loss = true;

       this.stock_list[index].stop_loss_error_text = 'Stop loss must be greater than reco price';
      }
     }
    } else {
     this.stock_list[index].reco_price_potential = this.getPotentailReturn(0, 0, reco_type);
     this.stock_list[index].validate_reco_price = true;
     this.stock_list[index].reco_price_error_text = 'Reco price must be positive integer';
    }
   } else if (reco_type == 'Hold') {
    if (reg.test(reco_price)) {
     this.stock_list[index].reco_price_potential = this.getPotentailReturn(reco_price, stock_price, reco_type);
     this.stock_list[index].target_price_potential = this.getPotentailReturn(target_price, reco_price, reco_type);
     this.stock_list[index].validate_reco_price = false;

     // validate target price input
     if (this.stock_list[index].target_price > reco_price) {
      let price = this.checkPercentageForHoldRecoType(this.stock_list[index].target_price, reco_price, 'INCREASE');

      if (this.stock_list[index].target_price > price) {
       this.stock_list[index].validate_target_price = true;
       this.stock_list[index].target_price_error_text = `Target price must be less than ${price.toFixed()}`;
      } else {
       this.stock_list[index].validate_target_price = false;
      }
     } else {
      let price = this.checkPercentageForHoldRecoType(this.stock_list[index].target_price, reco_price, 'DECREASE');

      if (this.stock_list[index].target_price < price) {
       this.stock_list[index].validate_target_price = true;
       this.stock_list[index].target_price_error_text = `Target price must be greater than ${price.toFixed()}`;
      } else {
       this.stock_list[index].validate_target_price = false;
      }
     }
    } else {
     this.stock_list[index].reco_price_potential = this.getPotentailReturn(0, 0, reco_type);
     this.stock_list[index].validate_reco_price = true;
     this.stock_list[index].reco_price_error_text = 'Reco price must be positive integer';
    }
   }
  },

  calculateStopLoss(reco_price, target_price, index) {
    this.stock_list[index].added_first = 'target price';
},

  calculateTargetPrice(reco_price, stop_loss, index) {
    this.stock_list[index].added_first = 'stop loss';
    reco_price = parseFloat(reco_price);
    let target_price_in_percent = Math.abs(((reco_price - stop_loss) / reco_price) * 100);

    if (this.stock_list[index].reco === 'Buy') {
      this.stock_list[index].target_price = (reco_price + (reco_price * target_price_in_percent) / 100).toFixed(2);
      this.stock_list[index].target_price_limit = this.stock_list[index].target_price;
    } else if (this.stock_list[index].reco === 'Sell') {
      this.stock_list[index].target_price = (reco_price - (reco_price * target_price_in_percent) / 100).toFixed(2);
      this.stock_list[index].target_price_limit = this.stock_list[index].target_price;
    }

    this.validateTargetPrice(this.stock_list[index].target_price, index, this.stock_list[index].reco);
  },

  // validate target price input
  validateTargetPrice(target_price, index, reco_type) {
   let reg = /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/; //regex for non negative values

   let reco_price = Number(this.stock_list[index].reco_price);

   this.stock_list[index].is_recommended = false;
   this.stock_list[index].is_unlocked = false; //to disable check antestimate link

   let twoDecimalOnly = /^\d*(\.\d{0,2})?$/; //regex for two decimal values
   if (!twoDecimalOnly.test(target_price)) {
    this.stock_list[index].target_price = Number(this.stock_list[index].target_price).toFixed(2);
   }
   if (reco_type == 'Buy') {
    // rounded value using toFixed() because current price is a fractional value
    if (reg.test(target_price) && Number(target_price) > reco_price) {
     this.stock_list[index].validate_target_price = false;
     this.stock_list[index].target_price_potential = this.getPotentailReturn(target_price, reco_price, reco_type);

     // // validate reco price input
     // if(this.stock_list[index].reco_price < target_price && this.stock_list[index].reco_price >= this.stock_list[index].current_price){
     //   this.stock_list[index].validate_reco_price = false;
     // }else{
     //   this.stock_list[index].validate_reco_price = true;
     //   this.stock_list[index].reco_price_error_text = "Reco price must be positive integer & greater than current price & lower than target price";
     // }
    } else {
     this.stock_list[index].target_price_potential = this.getPotentailReturn(0, 0, reco_type);
     this.stock_list[index].validate_target_price = true;
     this.stock_list[index].target_price_error_text = 'Target price must be positive integer and greater than reco price';
    }
   } else if (reco_type == 'Sell') {
    if (reg.test(target_price) && Number(target_price) < reco_price) {
     this.stock_list[index].validate_target_price = false;
     this.stock_list[index].target_price_potential = this.getPotentailReturn(target_price, reco_price, reco_type);
    } else {
     this.stock_list[index].target_price_potential = this.getPotentailReturn(0, 0, reco_type);
     this.stock_list[index].validate_target_price = true;
     this.stock_list[index].target_price_error_text = 'Target price must be positive integer and lower than reco price';
    }
   } else if (reco_type == 'Hold') {
    if (reg.test(target_price)) {
     if (target_price > reco_price) {
      let price = this.checkPercentageForHoldRecoType(target_price, reco_price, 'INCREASE');

      if (target_price > price) {
       this.stock_list[index].validate_target_price = true;
       this.stock_list[index].target_price_error_text = `Target price must be less than ${price.toFixed()}`;
      } else {
       this.stock_list[index].validate_target_price = false;
      }
     } else {
      let price = this.checkPercentageForHoldRecoType(target_price, reco_price, 'DECREASE');

      if (target_price < price) {
       this.stock_list[index].validate_target_price = true;
       this.stock_list[index].target_price_error_text = `Target price must be greater than ${price.toFixed()}`;
      } else {
       this.stock_list[index].validate_target_price = false;
      }
     }

     this.stock_list[index].target_price_potential = this.getPotentailReturn(target_price, reco_price, reco_type);
    } else {
     this.stock_list[index].target_price_potential = this.getPotentailReturn(0, 0, reco_type);
     this.stock_list[index].validate_target_price = true;
     this.stock_list[index].target_price_error_text = 'Target price must be positive integer';
    }
   }
  },

  // validate stop loss input
  validateStopLoss(stop_loss, index, current_price, reco_type) {
   if (stop_loss) {
    //ignored white spaces

    let reg = /^[+]?([1-9][0-9]*(?:[\.][0-9]*)?|0*\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$/; //regex for non negative values

    let reco_price = Number(this.stock_list[index].reco_price);

    this.stock_list[index].is_recommended = false;
    this.stock_list[index].is_unlocked = false; //to disable check antestimate link

    let twoDecimalOnly = /^\d*(\.\d{0,2})?$/; //regex for two decimal values
    if (!twoDecimalOnly.test(stop_loss) && stop_loss.includes('.')) {
     this.stock_list[index].stop_loss = Number(this.stock_list[index].stop_loss).toFixed(2);
    }

    if (reco_type == 'Buy') {
     // rounded value using toFixed() because current price is a fractional value
     if (reg.test(stop_loss) && Number(stop_loss) < reco_price) {
      this.stock_list[index].validate_stop_loss = false;
      this.stock_list[index].stop_loss_potential = this.getPotentailReturn(stop_loss, current_price, reco_type);
     } else {
      this.stock_list[index].stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
      this.stock_list[index].validate_stop_loss = true;
      this.stock_list[index].stop_loss_error_text = 'Stop loss must be positive integer and lower than reco price';
     }
    } else if (reco_type == 'Sell') {
     if (reg.test(stop_loss) && Number(stop_loss) > reco_price) {
      this.stock_list[index].validate_stop_loss = false;
      this.stock_list[index].stop_loss_potential = this.getPotentailReturn(stop_loss, current_price, reco_type);
     } else {
      this.stock_list[index].stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
      this.stock_list[index].validate_stop_loss = true;
      this.stock_list[index].stop_loss_error_text = 'Stop loss must be positive integer and greather than reco price';
     }
    } else if (reco_type == 'Hold') {
     if (reg.test(stop_loss)) {
      this.stock_list[index].validate_stop_loss = false;
      this.stock_list[index].stop_loss_potential = this.getPotentailReturn(stop_loss, current_price, reco_type);
     } else {
      this.stock_list[index].stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
      this.stock_list[index].validate_stop_loss = true;
      this.stock_list[index].stop_loss_error_text = 'Stop loss must be positive integer';
     }
    }
   } else {
    this.stock_list[index].validate_stop_loss = false;

    this.stock_list[index].stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
   }
  },

  checkPercentageForHoldRecoType(target_price, current_price, type) {
   let price = '';

   if (type == 'INCREASE') {
    price = current_price + (current_price * 4) / 100;
   } else {
    price = current_price - (current_price * 4) / 100;
   }
   return price;
  },

  //calculate protential return by target price(reco price) and current price
  getPotentailReturn(target_price, current_price, reco_type) {
   target_price = Number(target_price);
   current_price = Number(current_price);

   if (target_price && current_price && reco_type == 'Buy') {
    return (((target_price - current_price) / current_price) * 100).toFixed(2);
   } else if (target_price && current_price && reco_type == 'Sell') {
    return (((current_price - target_price) / current_price) * 100).toFixed(2);
   } else if (target_price && current_price && target_price > current_price && reco_type == 'Hold') {
    return (((target_price - current_price) / current_price) * 100).toFixed(2);
   } else if (target_price && current_price && target_price < current_price && reco_type == 'Hold') {
    return (((current_price - target_price) / current_price) * 100).toFixed(2);
   }

   return 0;
  },

  resetPotentialReturnAndTargetPrice(reco_type, index) {
   if (reco_type == 'Buy') {
    //reset target price by adding 1 beacuse reco type is Buy
    let target_price = (this.stock_list[index].current_price + 2).toFixed();
    let current_price = this.stock_list[index].current_price;

    let target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);
    let reco_price_potential = this.getPotentailReturn(current_price, current_price, reco_type);

    this.stock_list[index].reco_price = Number(current_price);
    this.stock_list[index].target_price = target_price;
    this.stock_list[index].stop_loss = '';

    //calculated potential return initially when price is initiallised
    this.stock_list[index].reco_price_potential = reco_price_potential;
    this.stock_list[index].target_price_potential = target_price_potential;
    this.stock_list[index].stop_loss_potential = '';
   } else if (reco_type == 'Sell') {
    //reset target price by decreasing 1 beacuse reco type is Sell
    let target_price = Number((this.stock_list[index].current_price - 2).toFixed());
    let current_price = this.stock_list[index].current_price;

    let reco_price_potential = this.getPotentailReturn(current_price, current_price, reco_type);
    let target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);

    this.stock_list[index].reco_price = Number(current_price);
    this.stock_list[index].target_price = target_price;
    this.stock_list[index].stop_loss = '';

    //calculated potential return initially when price is initiallised
    this.stock_list[index].reco_price_potential = reco_price_potential;
    this.stock_list[index].target_price_potential = target_price_potential;
    this.stock_list[index].stop_loss_potential = '';
   } else {
    //reset target price
    let target_price = Number(this.stock_list[index].current_price.toFixed()) + 1;
    let current_price = this.stock_list[index].current_price;

    let target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);
    let reco_price_potential = this.getPotentailReturn(current_price, current_price, reco_type);

    this.stock_list[index].reco_price = Number(current_price);
    this.stock_list[index].target_price = target_price;
    this.stock_list[index].stop_loss = '';

    //calculated potential return initially when price is initiallised
    this.stock_list[index].reco_price_potential = reco_price_potential;
    this.stock_list[index].target_price_potential = target_price_potential;
    this.stock_list[index].stop_loss_potential = '';
   }

   // disabled price error label
   this.stock_list[index].validate_target_price = false;
   this.stock_list[index].validate_reco_price = false;
   this.stock_list[index].validate_stop_loss = false;

   if (this.stock_list[index].target_price && this.stock_list[index].reco_price) {
    this.calculateStopLoss(this.stock_list[index].reco_price, this.stock_list[index].target_price, index);
   }
  },

  removeStockFromList(index) {
   this.stock_list.splice(index, 1);
  },

  goToLink(link) {
   if (link) {
    this.$router.push(link);
   }
  },

  loadMoreStocks() {
   window.onscroll = () => {
    //checked is window scrolled to bottom
    if (window.innerHeight + window.scrollY >= document.body.scrollHeight && this.is_scroll_disabled && this.number_of_pages > this.page_no) {
     this.page_no = this.page_no + 1;
     this.getAllStockList();
     this.is_scroll_disabled = false; //disabled scroll to avoid multiple time function call
    }
   };
  },

  loadStocks() {
   this.page_no = this.page_no + 1;
   this.number_of_pages = 0; //to disable load more tab
   this.getAllStockList();
  },

  //get all stocks list from api
  getAllStockList() {
   this.is_stock_list_loading = true;
   serverAddr
    .post('/recommendation/v1/read-stock', {
     key: 'stock',
     search: '',
     page_no: this.page_no,
    })
    .then(this.getAllStockListCallBack)
    .catch(
     function (error) {
      console.log(error);
      this.is_stock_list_loading = false;
     }.bind(this)
    );
  },

  //get all stocks list from api
  getStockById(stock_name) {
   this.is_stock_list_loading = true;
   serverAddr
    .post('/recommendation/v1/read-stock', {
     key: 'stock',
     search: stock_name ? stock_name : '',
     page_no: this.page_no,
    })
    .then(this.getStockByIdCallBack)
    .catch(
     function (error) {
      console.log(error);
      this.is_stock_list_loading = false;
     }.bind(this)
    );
  },

  //get target period list
  getTargetPeriod() {
   return serverAddr
    .get('/recommendation/v1/reco_target_period')
    .then((response) => {
     return response;
    })
    .catch(
     function (error) {
      console.log(error);
      this.is_stock_list_loading = false;
     }.bind(this)
    );
  },
  // open logic reference upload dialog
  openLogicReferenceDialog(item, index) {
   this.recos_to_be_upload = [];

   let obj = {};
   let is_stop_loss_required = false;
   let is_logic_description_required = false;

   obj.stockId = item.id;
   obj.reco = item.reco;
   obj.duration = '';
   obj.target_price = Number(item.target_price);
   obj.reco_open_price = Number(item.reco_price);
   obj.reco_price_type = item.reco_price_type;
   obj.risk_tag = item.risk_tags;

   if (item.stop_loss) {
    obj.stop_loss = Number(item.stop_loss);
   }

   obj.result_date = '';
   obj.number = '';
   obj.year = '';
   obj.upload_reco = 1; //for bulk upload send this value as 2
   if (item.result_date) {
    let target_res = item.target_period_array.filter((e) => {
     return e.result_date == item.result_date;
    });

    if (target_res.length) {
     obj.result_date = target_res[0].result_date;
     obj.number = target_res[0].number;
     obj.year = target_res[0].year;
     obj.duration = target_res[0].duration;
    }
   }

   if (obj.stockId && obj.reco && item.result_date && obj.target_price && !item.validate_target_price && !item.validate_reco_price && !item.validate_stop_loss && item.risk_tags.length) {
    if (item.selected_target_period == 'Short-Term' || item.selected_target_period == 'Intra' || item.selected_target_period == 'Mid-Term') {
     if (item.stop_loss) { let ratio = Math.abs( (obj.target_price - obj.reco_open_price) / (obj.reco_open_price - obj.stop_loss));   // Check 1:1  ration here
         if (ratio < 1) { new CripNotice({ title: 'Warning', description: 'Alert : Risk-Reward Ratio for this recommendation is below 1:1.', type: 'warning', duration: 3, });
          return;    // don't allow logic popup open
        }

        this.recos_to_be_upload.push(obj);
      } else {
        is_stop_loss_required = true;
      }
    } else {
      this.recos_to_be_upload.push(obj);
    }
  }

   if (this.recos_to_be_upload.length) {
    // remove data if logic box open at first time
    if (this.selected_stock_index != index) {
     this.selected_stock_index = index;
     this.attached_files_list = [];
     this.logic_description = '';
     this.selected_logic_list = [];
     this.selected_stamps_list = [];
    }

    this.upload_logic_reference_dialog_visible = true;
   } else {
    // validate_duration
    // duration_error_text
    var errDescription = '';
    if (!item.result_date) {
     errDescription = 'Duration is required to proceed';
    } else if (!obj.target_price) {
     errDescription = 'Target price is required to proceed';
    } else if (is_stop_loss_required) {
     errDescription = 'Stop loss is required to proceed';
    } else if (!obj.risk_tag) {
     errDescription = 'Risk tag is required to proceed';
    } else {
     errDescription = 'Please fill all fields in correct format';
    }
    // if (this.stock_list[index].validateSebiRegisterdUser && (!this.logic_description || !this.attached_files_list.length)) {
    //   new CripNotice({
    //     title: "Error",
    //     description: "Logic is compulsary for SEBI registered user",
    //     type: "error",
    //     duration: 3,
    //   });
    // } else {
    new CripNotice({
     title: 'Error',
     description: errDescription,
     type: 'error',
     duration: 2,
    });
    // }
   }
  },

  // api to upload recommendation
  uploadReco(item, index) {
   let is_logic_description_required = false;
   let is_category_stamp_required = false;
   // logic tags and description will come after logic box is open
   if (this.recos_to_be_upload.length == 1) {
    this.recos_to_be_upload[0].logic_tags = this.selected_logic_list;
   }

   // if user has selected less than 3 tags give error
   if (!this.selected_logic_list.length || this.selected_logic_list.length < 3) {
    is_logic_description_required = true;
   }

   // if user is not sebi registered but he has selected less than 3 tags give error
   if (!this.selected_stamps_list.length) {
    is_category_stamp_required = true;
   } else {
    this.recos_to_be_upload[0].category_stamp = this.selected_stamps_list;
   }

   if (this.recos_to_be_upload.length && !this.stock_list[index].validateSebiRegisterdUser && !is_logic_description_required && !is_category_stamp_required) {
    this.stock_list[index].is_btn_loading = true; //enabled btn loading
    serverAddr
     .post('/recommendation/v1/upload', {
      estimates: this.recos_to_be_upload,
      page_source: 'SINGLE_UPLOAD',
     })
     .then((response) => {
      this.uploadRecommendationNetWorkCallBack(response, index);
      this.upload_logic_reference_dialog_visible = false;
     })
     .catch((error) => {
      console.log(error);
      this.stock_list[index].is_btn_loading = false; //disabled btn loading
     });
   } else {
    if (is_logic_description_required) {
     new CripNotice({
      title: 'Error',
      description: 'Minimum 3 logic tags are required to proceed',
      type: 'error',
      duration: 2,
     });
    } else {
     new CripNotice({
      title: 'Error',
      description: 'Stamp is required to proceed',
      type: 'error',
      duration: 2,
     });
    }
   }
  },

  // filteredTargetPeriods(reco) {
  //   if (reco === "Sell") {
  //     // If reco is Sell, show only Intraday
  //     return this.target_period_type_list.filter(
  //       (period) => period.value === "Intra"
  //     );
  //   } else {
  //     // If reco is Buy, show all target periods
  //     return this.target_period_type_list;
  //   }
  // },
 },

 computed: {
  getPlanSubscriptionStatus() {
   return this.$store.state.planStatus;
  },

  //returns user profile from localstorage
  userProfile() {
   return JSON.parse(localStorage.getItem('profile'));
  },

  //returns subscribed plan details from local storage
  subscribedPlanDetails() {
   return JSON.parse(localStorage.getItem('plan_details'));
  },

  // filteredTags() {
  //   return this.tags_data[this.recoType][this.targetPeriod].map((tag) => ({
  //     value: tag,
  //     label: tag,
  //   }));
  // },
 },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.UploadRecommendation {
 min-height: 100vh;
 background-color: $page-background-color;
 padding: 60px 0 60px 0;

 .duration-margin {
  margin-top: 30px;
 }
}
.uploadForeCastedEstimateContainer {
 min-height: 100vh;
 padding: 60px 10px 0 10px;
}
.UploadRecommendation .action-container {
 box-sizing: border-box;
 position: fixed;
 margin-left: 0;
 padding: 0;
 width: 100%;
 z-index: 2;
}
.UploadRecommendation .search-stock-section {
 position: fixed;
 display: flex;
 justify-content: space-between;
 z-index: 2;
 box-sizing: border-box;
 background-color: $page-background-color;
 padding: 15px 10px;
 width: 100%;

 .stock-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .download-btn {
   margin-left: 10px;
  }

  .create-post-btn {
   background: linear-gradient(90deg, #2d2e8d 0%, #0c0d27 100%);
   color: #fff;
   border: none;
   font-size: 12;
   font-weight: 600;
   padding: 10px 20px;
   border-radius: 50px;
   display: flex;
   align-items: center;
   gap: 8px;
  }

  .create-post-btn:hover {
   opacity: 0.9;
  }
 }
}

.UploadRecommendation .sector-dropdown {
 min-width: 170px;
}
.rupees-symbol {
 position: absolute;
 top: 7px;
 left: 10px;
 z-index: 1;
 font-size: 0.9rem;
 color: black;
 font-weight: bold;
}
.percentSymbol {
 position: absolute;
 top: 5px;
 right: 80px;
 z-index: 1;
 color: #606266;
}
.unlocked-antestimate-notifybar {
 cursor: pointer;
 color: black;
 font-weight: 800;
 width: 100%;
 box-sizing: border-box;
 border-radius: 4px;
 position: relative;
 overflow: hidden;
 opacity: 1;
 display: flex;
 transition: opacity 0.2s;
 font-size: 1.2rem;
}
.selection-tag {
 font-size: 0.7rem;
 height: 25px;
 line-height: 24px;
}

.stock-details-section {
 display: flex;
 align-items: center;
}
.UploadRecommendation .stock-title {
 max-width: 300px;
}
.current-price {
 font-size: 1.2rem;
 font-weight: 600;
 color: #000;
}
.border-bottom-gray {
 border-bottom: 1px solid #ddd;
 padding-bottom: 10px;
}
.UploadRecommendation .cross-icon {
 color: #ddd;
 font-size: 20px;
 cursor: pointer;
}
.UploadRecommendation .cross-icon:hover {
 font-size: 20px;
 color: #000;
}
.summary-btn {
 position: absolute;
 top: 35px;
 left: 0;
 right: 0;
 font-size: 0.7rem;
 font-weight: 600;
 color: $secondary-theme-color;
 cursor: pointer;
 text-align: center;
}
.el-select-dropdown__item {
 color: #000 !important;
 font-weight: 300 !important;
}

.top-margin-5 {
 margin-top: 5px;
}

.note-text {
 font-weight: 500;
 font-size: 10px;
 color: #878787;
 margin-top: 3px;
 margin-bottom: 7px;
 margin-left: 5px;
}
@media screen and (max-width: 1283px) {
 .UploadRecommendation {
  padding: 50px 0 80px 0;
 }
 .uploadForeCastedEstimateContainer {
  padding: 80px 10px 0;
 }
 .UploadRecommendation .action-container {
  width: 100%;
 }
 .UploadRecommendation .search-stock-section {
  display: block;
  padding: 20px 10px 10px 10px;
  .stock-input {
   //  display: block;
   .download-btn {
    width: fit-content;
    margin: 10px auto;
   }
  }
 }
 .action-btn-component {
  display: flex;
  justify-content: center;
  margin: 10px auto;
 }
}
@media screen and (max-width: 1199px) {
 .UploadRecommendation .duration-margin {
  margin-top: 10px;
 }
}
@media screen and (max-width: 575px) {
 .stock-details-section {
  display: block;
 }
 .sector-capitalized-section {
  margin-top: 10px;
 }
 .UploadRecommendation .stock-title {
  max-width: 100px;
 }
 .UploadRecommendation .search-stock-section {
  .stock-input {
   display: flex;
   justify-content: space-between;
   .create-post-btn {
    font-size: 10px;
    font-weight: 600;
    padding: 8px 10px;
   }
  }
 }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
 color: #e72726 !important;
}

.UploadRecommendation {
 .el-select .el-tag__close.el-icon-close {
  background-color: #fff;
  color: #000;
 }
 .upload-logic-dialog {
  width: 600px;
  border-radius: 10px;
  .el-tag.el-tag--info {
   background-color: #e72726;
   border-color: #e72726;
   color: #fff;
   font-weight: 600;
   border-radius: 20px;
  }
  .el-dialog__header {
   padding: 0;
  }
  .el-dialog__body {
   padding: 10px 30px 30px;
  }
 }
}

.UploadRecommendation .box-card {
 border-radius: 10px !important;
 border: none;
 box-shadow: none;
 min-height: 430px;
}
.searched-stock-card {
 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}
.UploadRecommendation .target-price-input {
 width: 100%;
}
.UploadRecommendation .sector-dropdown .el-input__inner {
 border-radius: 12px;
 height: 20px;
 border-radius: 10px;
 font-size: 0.6rem;
 text-transform: uppercase;
 font-weight: 500;
 color: #000;
}
.UploadRecommendation .target-price-input-section .el-input__inner::placeholder {
 font-size: 0.8rem;
 font-weight: 500;
}

.UploadRecommendation .el-select .el-input .el-select__caret.is-reverse {
 position: absolute;
 top: -4px;
 right: 0;
}
.UploadRecommendation .sector-dropdown .el-select__caret {
 position: absolute;
 top: 3px;
 right: 0;
}
.UploadRecommendation .sector-dropdown .el-select__caret {
 font-size: 13px;
}
.UploadRecommendation .target-price-input .el-input__inner {
 //border-radius: 25px;
}
.UploadRecommendation .target-price-input .el-input-number__increase,
.UploadRecommendation .target-price-input .el-input-number__decrease {
 line-height: 0;
 border-radius: 50px;
 width: 22px;
 height: 22px;
 display: flex;
 justify-content: center;
 align-items: center;
 font-size: 20px;
 font-weight: bold;
 border: none;
 background-color: $secondary-theme-color;
 border-color: $secondary-theme-color;
 color: #fff;
 display: none;
}
.UploadRecommendation .target-price-input .el-input-number__decrease {
 right: 35px;
 top: 5px;
}
.UploadRecommendation .target-price-input .el-input-number__increase {
 right: 5px;
 top: 5px;
}

.UploadRecommendation .unlock-antestimate-btn {
 background-color: $page-background-color;
 // padding: 10px;
 padding: 9px 15px;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 0.7rem;
 // font-size: 0.8rem;
 font-weight: 500;
 border-radius: 50px;
 color: #b2b2b2;
}
.UploadRecommendation .target-price-input-section .el-input__inner {
 text-align: left;
 // height: 35px;
 padding-left: 23px;
 color: black;
 font-weight: 600;
 font-size: 0.9rem;
}
.UploadRecommendation .potential-return-value {
 font-size: 0.7rem;
 font-weight: 600;
 position: absolute;
 top: 8px;
 right: 8px;
 // right: 30%;
 z-index: 1;
 color: #979797;
}
.UploadRecommendation .inactive-period-type-tag {
 text-align: center;
 border-radius: 12px;
 padding: 0 10px;
 margin: 0 0.3rem 0 0;
 background-color: #fff;
 border-color: #d9d9d9;
 font-weight: 600;
 color: #878787;
 min-width: 50px;
 cursor: pointer;
 text-transform: uppercase;
 font-size: 10px;
}
.UploadRecommendation .disabled-period-type-tag {
 margin-right: 0.3rem;
 border-radius: 12px;
 padding: 0 10px;
 min-width: 50px;
 font-weight: 600;
 text-align: center;
 border-color: #ddd;
 background-color: #ddd;
 color: #fff;
 text-transform: uppercase;
 font-size: 10px;
 cursor: not-allowed;
}
.UploadRecommendation .active-period-type {
 margin-right: 0.3rem;
 border-radius: 12px;
 padding: 0 10px;
 min-width: 50px;
 font-weight: 600;
 text-align: center;
 border-color: $secondary-theme-color;
 background-color: $secondary-theme-color;
 color: #fff;
 text-transform: uppercase;
 font-size: 10px;
}
.UploadRecommendation .active-period-type:focus,
.UploadRecommendation .inactive-period-type-tag:focus {
 outline: none;
}
.UploadRecommendation .el-button.is-disabled.is-plain {
 border-radius: 61px;
}
.UploadRecommendation .el-button.is-disabled.is-plain {
 background-color: #eee;
}

.UploadRecommendation .antestimate-unlock-section .el-button {
 display: flex;
 align-items: center;
 padding: 8px 18px;
}
.UploadRecommendation .info-Logo {
 height: 9px;
 padding: 0px 2px 0px 3px;
}
.UploadRecommendation .NoDataFound {
 padding: 60px 0 0 0;
}
.UploadRecommendation .quarter-tag {
 // width: 170px;
 input {
  //border-radius: 25px;
  // height: 25px;
 }
 input::placeholder {
  // color: $primary-theme-color;
  // font-size: 10px;
  font-weight: 500;
 }
}

.UploadRecommendation .active-quarter {
 input {
  background-color: $secondary-theme-color;
  border-color: $secondary-theme-color;
  color: #fff;
 }
 .el-select__caret {
  color: #fff;
 }
}
.UploadRecommendation .upload-btn {
 background: #d6eaff;
 color: #4488d0;
 padding: 5px 15px;
 border-radius: 5px;
 font-size: 0.7rem;
 font-weight: 500;
 width: fit-content;
 cursor: pointer;
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
 .UploadRecommendation .box-card {
  min-height: 550px;
 }
}
@media screen and (min-width: 769px) and (max-width: 991px) {
 .UploadRecommendation .box-card {
  min-height: 375px;
 }
}
@media screen and (max-width: 768px) {
 .UploadRecommendation {
  .box-card {
   min-height: 545px;
  }

  .upload-logic-dialog {
   width: 80%;
  }
 }
}
@media screen and (max-width: 448px) {
 .UploadRecommendation {
  .upload-logic-dialog {
   width: 98%;
  }
  .SearchStock .search-stock-container {
   width: 97%;
  }
 }
}
.error-pop .el-popover {
 color: $primary-theme-color;
 width: auto !important;
 min-width: auto !important;
 word-break: break-word !important;
}

.el-select-group__title {
 color: $primary-theme-color !important;
}

.el-message-box .el-button--primary {
 background-color: $secondary-theme-color !important;
 border-color: $secondary-theme-color !important;
}
</style>
